import { mapState, mapActions } from 'vuex';

import { useDataLoading } from '@mixins/factories';

import {
  namespace as MachineCategoriesNamespace,
  ActionTypes as MachineCategoriesActionTypes,
} from '@modules/additional/machineCategories/store.types';

import MachineEditor from '../../_components/machineEditor';
import MachineDrawers from '../../_components/machineDrawers';
import MachineProxyTest from '../../_components/machineProxyTest';

const dataLoadingOptions = {
  getterName: 'getMachines',
  contentName: 'machines',
  dataParams: ['activeOnly'],
  searchable: false,
  paged: false,
};

const machinesHeaders = Object.freeze([
  { text: 'Name', value: 'name' },
  { text: 'Short Name', value: 'shortName' },
  { text: 'Category', value: 'category' },
  { text: 'Proxy Routing Key', value: 'proxyUrl' },
  { text: 'Stacker Height', value: 'stackerHeight' },
  { text: 'Default Tray Name', value: 'defaultTrayName' },
  { text: 'State', value: 'isEnabled' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'Machines',
  mixins: [
    useDataLoading(dataLoadingOptions),
  ],
  components: {
    MachineEditor,
    MachineDrawers,
    MachineProxyTest,
  },
  data() {
    return {
      machinesHeaders,
      editedMachine: {},
      activeOnly: true,
      editorDialog: false,
      isEditorCreateMode: true,
    };
  },
  computed: {
    ...mapState('machines', ['machines']),
    activeCount() {
      return this.machines.filter(machine => machine.isEnabled).length;
    },
    totalCount() {
      return this.machines.length;
    },
  },
  watch: {
    activeOnly() {
      this.$_refreshData();
    },
    suffix() {
      this.$_refreshData();
    },
  },

  created() {
    this.getDefaultMachineDescription();
    this.getMachineCategories();
    this.getAllSubstrates();
  },

  methods: {
    ...mapActions('machines', ['getMachines', 'changeMachineState', 'getDefaultMachineDescription']),
    ...mapActions(MachineCategoriesNamespace, {
      getMachineCategories: MachineCategoriesActionTypes.GET_MACHINE_CATEGORIES,
    }),
    ...mapActions('substrates', ['getAllSubstrates']),
    setEditedMachine(machine) {
      this.editedMachine = machine;
      this.isEditorCreateMode = false;
      this.editorDialog = true;
    },
    switchMachineState(currentState, name) {
      const nextState = !currentState;
      this.$VBlackerTheme.alert.warning({
        text: `${nextState ? 'Enable' : 'Disable'} machine ${name}`,
      }, async () => {
        this.$VBlackerTheme.openLoadingSpinner();
        try {
          await this.changeMachineState({ name, enabled: nextState });
          this.$_refreshData();
        } catch (e) {
          this.$VBlackerTheme.notification.error(e);
        } finally {
          this.$VBlackerTheme.closeLoadingSpinner();
        }
      });
    },
  },
};
